import { render, staticRenderFns } from "./InvoiceManage.vue?vue&type=template&id=4b51fdd8&scoped=true"
import script from "./InvoiceManage.vue?vue&type=script&lang=js"
export * from "./InvoiceManage.vue?vue&type=script&lang=js"
import style0 from "./InvoiceManage.vue?vue&type=style&index=0&id=4b51fdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51fdd8",
  null
  
)

export default component.exports